import React from 'react';
import {
    Box,
    Text,
    Tooltip,
    VStack,
    HStack,
    Badge,
    IconButton,
    useClipboard,
} from '@chakra-ui/react';
import { FaInfoCircle, FaCopy } from 'react-icons/fa';

const VRFInfo = ({ gameSeed, cardVRF, flipVRF, bonusMultiplier }) => {
    const { hasCopied: hasCopiedSeed, onCopy: onCopySeed } = useClipboard(gameSeed);
    
    return (
        <Box
            bg="whiteAlpha.100"
            p={4}
            borderRadius="lg"
            boxShadow="0 4px 12px rgba(0,0,0,0.2)"
            width="100%"
            maxW="600px"
            mt={4}
        >
            <VStack spacing={3} align="stretch">
                <HStack justify="space-between">
                    <Text color="yellow.300" fontWeight="bold">
                        Verifiable Random Function (VRF) Info
                    </Text>
                    <Tooltip label="VRF ensures fair and transparent randomness in the game">
                        <IconButton
                            icon={<FaInfoCircle />}
                            variant="ghost"
                            colorScheme="purple"
                            size="sm"
                            aria-label="VRF Info"
                        />
                    </Tooltip>
                </HStack>

                <Box bg="whiteAlpha.200" p={3} borderRadius="md">
                    <HStack justify="space-between">
                        <Text color="gray.300" fontSize="sm">Game Seed:</Text>
                        <HStack>
                            <Text color="white" fontSize="sm" fontFamily="monospace">
                                {gameSeed ? gameSeed.substring(0, 16) + '...' : 'N/A'}
                            </Text>
                            <IconButton
                                icon={<FaCopy />}
                                size="xs"
                                variant="ghost"
                                onClick={onCopySeed}
                                aria-label="Copy seed"
                            />
                        </HStack>
                    </HStack>
                </Box>

                <HStack spacing={4}>
                    <Box flex="1" bg="whiteAlpha.200" p={3} borderRadius="md">
                        <VStack align="stretch">
                            <Text color="gray.300" fontSize="sm">Card VRF:</Text>
                            <Badge colorScheme="purple">
                                {cardVRF ? cardVRF.toFixed(4) : 'N/A'}
                            </Badge>
                        </VStack>
                    </Box>

                    <Box flex="1" bg="whiteAlpha.200" p={3} borderRadius="md">
                        <VStack align="stretch">
                            <Text color="gray.300" fontSize="sm">Flip VRF:</Text>
                            <Badge colorScheme="purple">
                                {flipVRF ? flipVRF.toFixed(4) : 'N/A'}
                            </Badge>
                        </VStack>
                    </Box>

                    <Box flex="1" bg="whiteAlpha.200" p={3} borderRadius="md">
                        <VStack align="stretch">
                            <Text color="gray.300" fontSize="sm">Bonus Multiplier:</Text>
                            <Badge colorScheme="green">
                                {bonusMultiplier ? `${bonusMultiplier}x` : 'N/A'}
                            </Badge>
                        </VStack>
                    </Box>
                </HStack>

                <Box bg="purple.900" p={3} borderRadius="md">
                    <Text color="gray.300" fontSize="xs" textAlign="center">
                        Card VRF determines card type • Flip VRF determines bonus multiplier
                    </Text>
                </Box>
            </VStack>
        </Box>
    );
};

export default VRFInfo;
